if (!customElements.get("quick-view-product-modal")) {
  class QuickViewProductModal extends window.Component {
    constructor() {
      super();
      this.isInited = false;
      this.triggerButton = this.querySelector(".quick-view-button");
      this.modal = this.querySelector("dialog");
      this.closeButton = this.querySelector(".quickview-close");
      this.shareContentToToggle = $(this).find(".social")
      this.triggerButton.addEventListener("click", this.openModal.bind(this));
      this.closeButton.addEventListener("click", this.closeModal.bind(this));
    }

    handleOpenShare() {
      $(this)
        .find(".btn-open")
        .on("click", (e) => {
          e.preventDefault();
          this.shareContentToToggle.toggleClass("open");
        });
    }

    init() {
      this.openSliderForQuickView();
      this.handleOpenShare();
    }

    openModal(e) {
      e.stopPropagation();
      this.modal.showModal();
      document.body.style.overflow = 'hidden'; 
      this.triggerClickOnFirstWaist();
      if (!this.isInited) {
        this.isInited = true;
        this.init();
      }
    }

    openSliderForQuickView() {
      $(this).find(".image--slider").not(".slick-initialized").slick({
        dots: false,
        autoplay: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: true,
        initialSlide: 0,
       prevArrow: $(this).find(".prev"),
        nextArrow: $(this).find(".next"),
      });
    }

    triggerClickOnFirstWaist() {
      const firstWaistInput = document.querySelector('input[name="Waist"]');
      const firstSizeInput = document.querySelector('input[name="Size"]');
      
      if (firstWaistInput) {
        firstWaistInput.click();
      }

      if (firstSizeInput) {
        firstSizeInput.click();
      }
    }

    closeModal() {
      this.modal.close();
      this.shareContentToToggle.removeClass("open");
      document.body.style.overflow = '';
    }

    disconnectedCallback() {
      this.triggerButton.removeEventListener("click", this.openModal);
      this.closeButton.removeEventListener("click", this.closeModal);
    }
  }

  customElements.define("quick-view-product-modal", QuickViewProductModal);
}
